import { Component, inject } from '@angular/core';
import { InfoModal } from './info.modal';
import { BsModalRef } from 'ngx-bootstrap/modal';


import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class InfoComponent {
    public readonly bsModalRef = inject(BsModalRef);

    get infoModal(): InfoModal {
        return this._infoModal;
    }

    set infoModal(value: InfoModal) {
        this._infoModal = value;
    }

    private _infoModal!: InfoModal;
}
